export const FORM_STRUCTURE = [
  {
    fields: [
      { label: 'Name', key: 'name' },
      { label: 'Address', key: 'streetAddress' },
    ],
  },
  {
    fields: [
      { label: 'City', key: 'city' },
      { label: 'State', key: 'state' },
      { label: 'Zipcode', key: 'zipcode' },
    ],
  },
  {
    fields: [
      { label: 'Timezone', key: 'timezone', defaultValue: 'Pacific' },
      { label: 'Phone', key: 'phone', defaultValue: '' },
    ],
  },
  {
    fields: [{ label: 'Website', key: 'website', defaultValue: '' }],
  },
];
